import React from "react";

const EditText: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.17871 9.20833H15.0954V11.375H3.17871V9.20833ZM3.17871 7.04167H15.0954V4.875H3.17871V7.04167ZM3.17871 15.7083H10.762V13.5417H3.17871V15.7083ZM19.4395 12.3175L20.2087 11.5483C20.6312 11.1258 21.3137 11.1258 21.7362 11.5483L22.5054 12.3175C22.9279 12.74 22.9279 13.4225 22.5054 13.845L21.7362 14.6142L19.4395 12.3175ZM18.6704 13.0867L12.9287 18.8283V21.125H15.2254L20.967 15.3833L18.6704 13.0867Z"
        fill="black"
      />
    </svg>
  );
};

export default EditText;
